import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface BvFormLabelSignature {
  Args: {
    hidden?: boolean;
    labelFor: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvFormLabelComponent = <template>
  <div class='bv-form-label {{if @hidden "bv-form-label--hidden"}}' ...attributes>
    <label for={{@labelFor}} class='bv-form-label__text'>
      {{yield}}
    </label>
  </div>
</template> satisfies TemplateOnlyComponent<BvFormLabelSignature>;

export default BvFormLabelComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvFormLabel: typeof BvFormLabelComponent;
    'bv-form-label': typeof BvFormLabelComponent;
  }
}
